import { postOrder } from '@/domain/orders/api';
import { registerResetFn } from '@/store/reset';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { type CartForm, type CartProduct } from '../types';

interface PostCartProps extends CartForm {
  country: string;
}

export interface CartStore {
  cartProducts: CartProduct[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CartStore = { cartProducts: [], isLoading: false, error: null };

export const useCartStore = create<CartStore>()(
  persist(() => ({ ...initialState }), {
    name: 'storage-cart',
    version: 1,
    partialize: (state) => ({ cartProducts: state.cartProducts }),
  }),
);

registerResetFn(() => useCartStore.setState(initialState));

export const addToCart = (product: CartProduct) => {
  const { idProduct, product: name, image2, group, documentation } = product;
  useCartStore.setState((state) => ({
    cartProducts: [...state.cartProducts, { idProduct, product: name, image2, group, documentation }],
  }));
};

export const removeFromCart = (id: number) => {
  useCartStore.setState((state) => ({
    cartProducts: state.cartProducts.filter((p) => p.idProduct !== id),
  }));
};

export const resetCart = () => {
  useCartStore.setState({ cartProducts: [], isLoading: false, error: null });
};

export const postCart = async (data: PostCartProps) => {
  const { cartProducts } = useCartStore.getState();
  useCartStore.setState({ isLoading: true, error: null });
  try {
    await postOrder({ ...data, products: cartProducts });
    useCartStore.setState({ isLoading: false, cartProducts: [] });
  } catch (error) {
    useCartStore.setState({ isLoading: false, error: error instanceof Error ? error.message : 'Unknown error' });
    throw error;
  }
};
